<template>
    <div class="fooder">
        <div class="container">
            <div class="top">
                <div class="left">
                    <h2>西安影墨教育</h2>
                    <div class="tab">
                        <div class="item">
                            <router-link to="/about" style="color:#fff; text-decoration: none;font-size: 18px; ">
                                <a>关于我们</a>
                            </router-link>
                        </div>
                        <div class="item">
                            <router-link to="/product" style="color:#fff; text-decoration: none;font-size: 18px ">
                                <a>产品与服务</a>
                            </router-link>
                        </div>
                        <div class="item">
                            <router-link to="/news" style="color:#fff; text-decoration: none;font-size: 18px; ">
                                <a>新闻中心</a>
                            </router-link>
                        </div>
                        <div class="item">
                            <router-link to="/contact" style="color:#fff; text-decoration: none;font-size: 18px; ">
                                <a>联系我们</a>
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- <div class="ewm">

                </div> -->
            </div>
            <div class="bottom">
                <!-- <p>陕ICP备12018634号-6 / 陕ICP证160123号 西安市公安局高新分局备案编号:{{ filing_number }}
                </p> -->
                <a style="opacity: 0.6;color:#fff" href="http://beian.miit.gov.cn/" target="blank">{{ filing_number }}</a>
                <p>Copyright © 2020-<span style="font-size: 14px;" id="currentYear"></span> {{ company_name }} </p>
            </div>
        </div>
    </div>
</template>
  
<script>
import { addressList } from "@/api/index";
export default {
    name: 'HeadCommon',
    // methods: {
    //     isActive(route) {
    //         // 路由调转的路径三等于调用传递过来的路径的时候，就增加active的类的样式
    //         return this.$route.path === route;
    //     }
    // }
    data() {
        return {
            filing_number: '',
            company_name: ''
        }
    },
    created() {
        this.FilingNumber()
        this.getCurrentYear(); // 添加这一行，以便在组件创建时获取当前年份
    },
    methods: {
        async FilingNumber() {
            const { data } = await addressList()
            console.log(data, 444);
            this.filing_number = data.filing_number
            this.company_name = data.company_name
        },
        async getCurrentYear() {
            await this.$nextTick(); // 等待DOM渲染完成
            const currentYear = new Date().getFullYear();

            // 将当前年份填充到文档中
            document.getElementById('currentYear').textContent = currentYear;
        },
    }
}
</script>
  
<style scoped>
@import '../style/common.css';
@import '../style/basic.css'
</style>